import {
  DEFAULT_DASH_LANGUAGE,
  DashLanguages,
  normalizeDashLanguage,
} from "dash-common";

type PortalLanguageInput = {
  enabled: boolean;
  pick?: DashLanguages | null;
  account?: { language?: string | null } | null;
  browser?: DashLanguages | null;
};

/**
 * This browser's pick beats the account language, which beats the browser
 * language. A signed-in account without a language reads as English.
 */
export const resolvePortalLanguage = ({
  enabled,
  pick,
  account,
  browser,
}: PortalLanguageInput): DashLanguages => {
  if (!enabled) return DEFAULT_DASH_LANGUAGE;
  if (pick) return pick;
  if (account) {
    return normalizeDashLanguage(account.language) ?? DEFAULT_DASH_LANGUAGE;
  }
  return browser ?? DEFAULT_DASH_LANGUAGE;
};
